/**
 * Support PIN modal — Alpine component, relocated from inline <script> in
 * layout_default. Registered via Alpine.data('SupportPinModal') in meroserver.js.
 * The one translated string is read from the root element's data-err-msg.
 */
export default function supportPinModal() {
    return {
        isOpen:         false,
        loading:        false,
        regenerating:   false,
        confirmingRegen: false,
        pin:            null,
        digits:         ['','','','','',''],
        revealed:       false,
        copied:         false,
        regenSuccess:   false,

        open: function () {
            this.isOpen          = true;
            this.regenSuccess    = false;
            this.confirmingRegen = false;
            if (!this.pin) this.load();
        },

        close: function () {
            this.isOpen          = false;
            this.revealed        = false;
            this.copied          = false;
            this.confirmingRegen = false;
        },

        load: function () {
            var self = this;
            self.loading = true;
            API.client.get('supportpin/get', {}, function (r) {
                self.loading = false;
                self.setPin(r.pin);
            }, function () {
                self.loading = false;
            });
        },

        setPin: function (value) {
            this.pin    = value || '';
            this.digits = this.pin ? this.pin.split('') : ['','','','','',''];
        },

        regen: function () {
            var self = this;
            self.confirmingRegen = false;
            self.regenerating    = true;
            self.regenSuccess    = false;
            API.client.post('supportpin/regenerate', {}, function (r) {
                self.regenerating = false;
                self.setPin(r.pin);
                self.revealed     = true;
                self.regenSuccess  = true;
                setTimeout(function () { self.regenSuccess = false; }, 4000);
            }, function (e) {
                self.regenerating = false;
                alert(e && e.message ? e.message : (this.$el.getAttribute('data-err-msg') || 'An error occurred.'));
            });
        },

        copyPin: function () {
            if (!this.pin) return;
            var self = this;
            navigator.clipboard.writeText(this.pin).then(function () {
                self.copied = true;
                setTimeout(function () { self.copied = false; }, 2500);
            });
        }
    };
}
